const requiredRule = (message: string) => ({
    required: true,
    message,
    trigger: ["blur", "change"],
});

export const validationRules = {
    banco: [
        requiredRule("El campo es obligatorio."),
    ],
};